export default __webpack_public_path__ + "static/dreamer-b787ed08356dba904dc9bc03f344a6bf.svg";